
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { EntityAcreditacionEmpresaService } from './entity-acreditacion-empresa.service';
import {
  EntityAcreditacionEmpresaAddFailure,
  EntityAcreditacionEmpresaAddRequest,
  EntityAcreditacionEmpresaAddSuccess,
  EntityAcreditacionEmpresaDeleteFailure,
  EntityAcreditacionEmpresaDeleteSuccess,
  EntityAcreditacionEmpresaLoadFailure,
  EntityAcreditacionEmpresaLoadRequest,
  EntityAcreditacionEmpresaLoadSuccess,
  EntityAcreditacionEmpresaUpdateFailure,
  EntityAcreditacionEmpresaUpdateRequest,
  EntityAcreditacionEmpresaUpdateSuccess
} from './entity-acreditacion-empresa.actions';
import { catchError, map, mergeMap, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import { NotificationService } from '../../../core/core.module';
import { Router } from '@angular/router';

@Injectable()
export class EntityAcreditacionEmpresaEffects {
  constructor(
    private actions$: Actions,
    private EntityAcreditacionEmpresaService: EntityAcreditacionEmpresaService,
    private notificationService: NotificationService,
    private router: Router,
  ) { }

  loadRequest = createEffect(() =>
    this.actions$.pipe(
      ofType(EntityAcreditacionEmpresaLoadRequest),
      mergeMap(() =>
        this.EntityAcreditacionEmpresaService.getAll().pipe(
          map((items) => EntityAcreditacionEmpresaLoadSuccess({ items })),
          catchError((error) => of(EntityAcreditacionEmpresaLoadFailure({ error })))
        )
      )
    )
  );

  addRequest = createEffect(() =>
    this.actions$.pipe(
      ofType(EntityAcreditacionEmpresaAddRequest),
      mergeMap((action) =>
        this.EntityAcreditacionEmpresaService.add(action.item).pipe(
          map((item) => EntityAcreditacionEmpresaAddSuccess({ item })),
          catchError((error) => of(EntityAcreditacionEmpresaAddFailure({ error })))
        )
      )
    )
  );

  updateRequest = createEffect(() =>
    this.actions$.pipe(
      ofType(EntityAcreditacionEmpresaUpdateRequest),
      mergeMap((action) =>
        this.EntityAcreditacionEmpresaService.update(action.item).pipe(
          map((item) => EntityAcreditacionEmpresaUpdateSuccess({ item })),
          catchError((error) => of(EntityAcreditacionEmpresaUpdateFailure({ error })))
        )
      )
    )
  );

  addSuccess = createEffect(
    () =>
      this.actions$.pipe(
        ofType(EntityAcreditacionEmpresaAddSuccess),
        tap(() => {
          this.notificationService.success('Acreditacion de la empresa registrada correctamente.')
          this.router.navigateByUrl('/main/principal');
        })
      ),
    { dispatch: false }
  );

  addFailure = createEffect(
    () =>
      this.actions$.pipe(
        ofType(EntityAcreditacionEmpresaAddFailure),
        tap(() =>
          this.notificationService.error('Error al registrar la acreditacion de la empresa.')
        )
      ),
    { dispatch: false }
  );

  updateSuccess = createEffect(
    () =>
      this.actions$.pipe(
        ofType(EntityAcreditacionEmpresaUpdateSuccess),
        tap(() =>
          this.notificationService.success(
            'Acreditacion de la empresa actualizada correctamente.'
          )
        )
      ),
    { dispatch: false }
  );

  updateFailure = createEffect(
    () =>
      this.actions$.pipe(
        ofType(EntityAcreditacionEmpresaUpdateFailure),
        tap(() =>
          this.notificationService.error('Error al actualizar la acreditacion de la empresa.')
        )
      ),
    { dispatch: false }
  );

  deleteSuccess = createEffect(
    () =>
      this.actions$.pipe(
        ofType(EntityAcreditacionEmpresaDeleteSuccess),
        tap(() =>
          this.notificationService.success(
            'Acreditacion de la empresa eliminada correctamente.'
          )
        )
      ),
    { dispatch: false }
  );

  deleteFailure = createEffect(
    () =>
      this.actions$.pipe(
        ofType(EntityAcreditacionEmpresaDeleteFailure),
        tap(() =>
          this.notificationService.error('Error al eliminar la acreditacion de la empresa.')
        )
      ),
    { dispatch: false }
  );
}
